<script setup lang="ts">
import {
  ASYNC_OVERLAY_DELAY_MS,
  defineAsyncWithSkeleton,
} from '~/utils/defineAsyncWithSkeleton'

const AppToolbox = defineAsyncWithSkeleton(
  function loadAppToolbox() {
    return import('~/components/app/AppToolbox.vue')
  },
  undefined,
  ASYNC_OVERLAY_DELAY_MS,
)

const OrganizationTreeModal = defineAsyncWithSkeleton(
  function loadOrganizationTreeModal() {
    return import('~/components/organization/OrganizationTreeModal.vue')
  },
  undefined,
  ASYNC_OVERLAY_DELAY_MS,
)

defineProps<{
  showToolbox: boolean
  loggedIn: boolean
  canEditOrganigramOnCurrentView: boolean
  isEditing: boolean
  geolocateLoading: boolean
  editModeShortcutKeys: string[]
  editModePressedKeys: boolean[]
  editModeSublimation: boolean
  toolboxShortcutKeys: string[]
  toolboxPressedKeys: boolean[]
  toolboxSublimation: boolean
  geolocShortcutKeys: string[]
  geolocPressedKeys: boolean[]
  geolocSublimation: boolean
  toolboxOpen: boolean
  organizationTreeModalOpen: boolean
  canUseOrganizationTree: boolean
}>()

const emit = defineEmits<{
  'update:toolboxOpen': [value: boolean]
  geolocate: []
  openTree: []
  'update:isEditing': [value: boolean]
  'update:organizationTreeModalOpen': [value: boolean]
}>()
</script>

<template>
  <OrganizationTreeModal
    v-if="organizationTreeModalOpen && canUseOrganizationTree"
    :model-value="organizationTreeModalOpen"
    @update:model-value="emit('update:organizationTreeModalOpen', $event)"
  />
  <AppToolbox
    v-if="showToolbox"
    :logged-in="loggedIn"
    :can-edit="canEditOrganigramOnCurrentView"
    :is-editing="isEditing"
    :geolocate-loading="geolocateLoading"
    :edit-mode-shortcut-keys="editModeShortcutKeys"
    :edit-mode-pressed-keys="editModePressedKeys"
    :edit-mode-sublimation="editModeSublimation"
    :toolbox-shortcut-keys="toolboxShortcutKeys"
    :toolbox-pressed-keys="toolboxPressedKeys"
    :toolbox-sublimation="toolboxSublimation"
    :geoloc-shortcut-keys="geolocShortcutKeys"
    :geoloc-pressed-keys="geolocPressedKeys"
    :geoloc-sublimation="geolocSublimation"
    :open="toolboxOpen"
    :can-use-organization-tree="canUseOrganizationTree"
    @update:open="emit('update:toolboxOpen', $event)"
    @geolocate="emit('geolocate')"
    @open-tree="emit('openTree')"
    @update:is-editing="emit('update:isEditing', $event)"
  />
</template>
